import { render, staticRenderFns } from "./index-list.vue?vue&type=template&id=74f934f8&scoped=true&"
import script from "./index-list.vue?vue&type=script&lang=js&"
export * from "./index-list.vue?vue&type=script&lang=js&"
import style0 from "./index-list.vue?vue&type=style&index=0&id=74f934f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f934f8",
  null
  
)

export default component.exports